<template>
  <div>
    <hr style="background-color: white" />
    <!-- {{
      items.filter((f) => {
        return f.permitted || $root.isHost;
      })
    }} -->
    <v-text-field
      v-if="!$root.isMobile  && !$root.customerId"
      class="pl-4 ma-2"
      label="Search Menu"
      clearable
      single-line
      hide-details
      append-icon="mdi-magnify"
      v-model="searchQuery"
      @click:clear="clearResults"
      @input="filterItems"
    ></v-text-field>
    <!-- {{ items }} -->

    <v-list
      :class="'left-menu' + !$root.isMobile ? '' : 'mt-12'"
      v-if="items && items.length > 0"
    >
      <template
        v-for="item in items.filter((f) => {
          return f.permitted || $root.isHost;
        })"
      >
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading">
              {{ item.heading }}
            </v-subheader>
          </v-col>
          <v-col cols="6" class="text-center">
            <a href="#!" class="body-2">EDIT</a>
          </v-col>
        </v-row>
        <v-list-group
          v-else-if="item.children"
          :key="item.key"
          v-model="item.model"
          :prepend-icon="item.model ? item.icon : item['icon-alt']"
          append-icon=""
        >
          <template v-slot:activator>
            <v-list-item-content class="">
              <v-list-item-title>
                {{
                  $root.customerId ? item.customerText || item.text : item.text
                }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            class="ml-6"
            draggable="true"
            @dragstart="dragStart($event, child)"
            @dragover.prevent
            @drop="dropItem"
            v-for="(child, i) in item.children.filter((f) => {
              return f.permitted;
            })"
            :key="child.key"
            :ref="child.ref"
            :to="child.link"
            @click="addToTab(child)"
            link
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          draggable="true"
          @dragstart="dragStart($event, item)"
          @dragover.prevent
          @drop="dropItem"
          v-else
          :key="item.link"
          @click="addToTab(item)"
          :to="getLinkTo(item)"
          link
        >
          <v-list-item-action>
            <v-icon>{{
              $root.customerId ? item.customerIcon || item.icon : item.icon
            }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="ml-0">
              {{
                $root.customerId ? item.customerText || item.text : item.text
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!--        :key="item.detail_key"-->
        <div
          v-if="item.details && item.details.length"
          :key="item.detail_key"
          class="ml-0 mr-1 pr-0"
        ></div>
      </template>
    </v-list>

    <div class="d-flex justify-center pa-2" v-else>
      You have no permissions!
    </div>
  </div>
</template>
<script>
import * as fun from "../plugins/common";
import axios from "axios";
export default {
  props: {
    resentTabs: Array,
    openTabs: Array,
    allowedRoutes: Array,
    removedRoutes: Array,
    all_items: Array,
  },
  data() {
    return {
      panel: 0,
      resentTabsItems: [],
      // all_items: null,
      searchQuery: "",
      items: [],
      linkTo: String,
    };
  },
  methods: {
    getLinkTo(item) {
      return item.customerLink && this.$root.customerId
        ? item.customerLink + "/" + this.$root.customerId.$oid
        : item.link;
    },
    dragStart(e, item) {
      var shortcut = {
        text: item.text,
        link: item.link,
        icon: item.icon,
      };
      e.dataTransfer.setData("item", JSON.stringify(shortcut));
      console.log(item);
    },
    dropItem(e, item) {
      // e.dataTransfer.setData("item", JSON.stringify(item));
      console.log("drop", item);
    },
    clearResults() {
      this.searchQuery = "";
      this.filterItems();
    },
    filterItems() {
      let firstMatchId = null;
      this.items.forEach((item) => {
        if (item.children) {
          const foundChild = item.children.find(
            (child) =>
              child.text
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase()) && child.permitted
          );
          if (foundChild) {
            item.model = true; // Expand parent
            if (!firstMatchId) {
              firstMatchId = `child-${foundChild.key}`; // Assuming `key` is unique
            }
            this.$nextTick(() => {
              if (firstMatchId) {
                const el = this.$refs[firstMatchId][0].$el;
                if (el) {
                  el.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start",
                  });
                  // const scrollableContainer = el.offsetParent; // This should be the scrollable container, adjust as necessary
                  // const elementTop = el.offsetTop; // Top position relative to its offsetParent
                  // scrollableContainer.scrollTop =
                  //   elementTop - scrollableContainer.offsetTop; // Adjust if you want some padding or offset

                  // Apply highlighting logic
                  el.classList.add("highlighted-item");
                  // Remove highlight after some time if desired
                  setTimeout(
                    () => el.classList.remove("highlighted-item"),
                    5000
                  );
                } else {
                  console.log("Ref not found:", firstMatchId);
                }
              }
            });
          } else {
            item.model = this.searchQuery === ""; // Collapse or reset based on search query
          }
        }
      });
    },

    getResentShipments() {
      return this.$props.resentTabs;
    },
    addToTab(m) {
      this.$root.addResentTab(m);
    },
    removeTab(tab_item) {
      this.$root.removeResentTab(tab_item);
    },
  },
  computed: {
    /**
     * Computed IS HOST status
     * @returns {boolean}
     */
    isHost: function() {
      return this.$store.getters["auth/user"].roles.includes("HOST");
    },
  },

  watch: {
    // searchQuery() {
    //   if (!this.searchQuery) {
    //     this.filterItems();
    //   }
    // },
    resentTabs: {
      handler: function(newResentTabs) {
        // console.log("Resent Tabs Updated!");
        this.resentTabsItems = newResentTabs;
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    if (localStorage.getItem("menuItems")) {
      this.items = JSON.parse(localStorage.getItem("menuItems"));
      // console.log(this.items);
      return;
    }
    this.removedRoutes.length = 0;
    this.allowedRoutes.length = 0;
  },
};
</script>
<style>
.highlighted-item {
  background-color: yellow; /* Light grey, adjust as needed */
}
.fixed-menu {
  position: fixed;
  top: -5px;
  left: 0;
  margin-right: 20px;
  z-index: 10000;
  background-color: #ffffff;
}
.theme--dark .fixed-menu {
  background-color: #000;
}

.blue {
  /* background-color: rgb(8, 147, 206) !important; */
}

.left-menu .v-icon {
  /* color: #ffffff !important; */
}
/* .left-menu .v-navigation-drawer__content {
  background-color: rgb(8, 147, 206) !important;
} */
.v-icon.v-icon {
  /* color: white !important; */
}
.left-menu .v-list-item__icon {
  /* background-color: red !important; */
}
.left-menu {
  /* height: 100vh !important; */
}

/* .v-navigation-drawer {
  background-color: rgb(8, 147, 206) !important;
} */
/* .left-menu .v-list-item,
.left-menu .v-list-group {
  background-color: rgb(8, 147, 206) !important;
} */
.left-menu .v-list {
  /* background-color: rgb(8, 147, 206) !important; */

  /* color: white; */
}
.theme--dark .left-menu .v-list-item__title {
  font-size: 16px !important;
  color: white;
}
.theme--dark .v-list-item__icon {
  color: #ffffff !important;
}
.left-menu .v-navigation-drawer__content {
  /* background-color: rgb(8, 147, 206) !important; */
  /* height: 100%; */
}
/* .v-icon {
  color: white !important;
} */
</style>
